import {IFBErrorResponse} from "../extplat/facebook/Facebook";

interface IApiPublicError{
    httpStatusCode: number;
    safeMsg: string;
    data: Map<string, string>;
}

interface IApiPublicErrorTyped<T> extends IApiPublicError{
        obj: T | null;
}

class ApiPublicErrorUtil {

    static dataToJson<T>(key: string, data: Map<string, string>): T | null {
        const jsonStr = data.get(key);
        if(jsonStr){
            try {
                const jsonObj: T = JSON.parse(jsonStr);
                return jsonObj;
            } catch (err){
                console.log(err);
                return null;
            }
        } else {
            console.log(`Failed to convert error type ${key}. was not valid json.`);
            console.log(jsonStr);
            return null;
        }
    }

    static toTypedError<T>(key: string, err1: IApiPublicError): IApiPublicErrorTyped<T> {
        const typedObj = ApiPublicErrorUtil.dataToJson<T>(key, err1.data);
        return {
            httpStatusCode: err1.httpStatusCode,
            safeMsg: err1.safeMsg,
            data: err1.data,
            obj: typedObj
        };
    }

}

export {IApiPublicError, IApiPublicErrorTyped, ApiPublicErrorUtil};